import './MouseEvent.css';
import React, { useRef } from 'react';
import { useEffect } from 'react';

export default function MouseEvent() {
  // you can use refs to interact with DOM elements
  // referencje do elementów DOM (zamiast id)
  const redBoxRef = useRef(null);
  const tableRef = useRef(null);
  const selectRef = useRef(null);
  const containerRef = useRef(null); // cały dokument

  // aby użyć listeneterów na elementach DOM, używamy useEffect()
  useEffect(() => {

    const redBox = redBoxRef.current;
    const table = tableRef.current;
    const select = selectRef.current;
    const container = containerRef.current;

    // Funkcja do uzupełniania tabeli
    function populateMouseEventProperties(event) {
      //const table = document.getElementById('mouse-event-properties');
      // Czyszczenie poprzednich danych
      table.innerHTML = `
          <tr>
              <th class='mouse-event-th'>Nazwa</th>
              <th class='mouse-event-th'>Wartość</th>
          </tr>
      `;
      // właściwości eventu
      const properties = [
          "type", "screenX", "screenY", "clientX", "clientY", 
          "pageX", "pageY", "offsetX", "offsetY", 
          "button", "buttons", "ctrlKey", "altKey", "metaKey","shiftKey", "movementX", "movementY"
      ];

      for (let property of properties) {
          const row = table.insertRow();
          row.className="mouse-event-tr";
          const nameCell = row.insertCell();
          const valueCell = row.insertCell();

          nameCell.textContent = property;
          valueCell.textContent = event[property] !== undefined ? event[property] : 'N/D';
      }
    }

    //let div = document.getElementsByTagName("div")[0];
    //let redBox = document.getElementById("redBox")
    //let select = document.getElementsByTagName("select")[0];
    let newEventType = "";
    let oldEventType = "";

    select.addEventListener("change",()=>{    // nasłuchiwanie zmian w selekcie
            
          newEventType = select.value;    // wybrany z selectu typ eventu
          
          redBox.removeEventListener(oldEventType, go);   // usunięcie poprzedniego typu
          redBox.addEventListener(newEventType, go);      // nasłuchiwanie wybranego typu eventu

          oldEventType = newEventType;   // ustawienie poprzedniego typu eventu
    })

    // funkcja odpalana eventem
    function go(event){
        populateMouseEventProperties(event);
    }

    /*
    *
    * ruch kwadratu za pomocą myszki
    *
    */

    //const container = document.getElementById('myContainer');   // cały dokument

    // falaga umożliwiająca odklejenie diva od wskażnika myszy
    let flag = false;

    // a - przyklejamy kwadrat do wskaźnika myszy
    // q - odklejamy
    document.addEventListener('keydown', function(event) {
        //const output = document.getElementById('output');
        //output.textContent = `Wciśnięto klawisz: ${event.key}`;
        
        if (event.key == "a"){
            //alert(event.key)
            flag = true
        } else if (event.key == "q"){
            flag = false;
        }
      }
    );

    container.addEventListener('mousemove', (event) => { 
      const x = event.clientX - (redBox.offsetWidth / 2) - 600;
      const y = event.clientY - (redBox.offsetHeight / 2) - 250;
      //const x = event.screenX - (redBox.offsetWidth / 2);
      //const y = event.screenY - (redBox.offsetHeight / 2);
      if(flag){
        redBox.style.transform = `translate(${x}px, ${y}px)`;  // przyklejamy div do wskaźnika myszy
      }
    });

      // TODO
    // Clean up the event listener on component unmount
    return () => {
      // document.removeEventListener('scroll', handleScroll);
    };
            
    }, []);// Empty dependencies array means this runs once on mount and cleanup on unmount

    
    return (
      <div>
        <section id="mouse-event-container" ref={containerRef}>
      
        <div id="mouse-event-red-box" ref={redBoxRef}></div>

        <h1>Właściwości obiektu MouseEvent</h1>
        
        
        
        <select id="mouse-event-select" ref={selectRef}>
            <option></option>
            <option value="click">click</option>
            <option value="dblclick">dblclick</option>
            <option value="mousedown">mousedown</option>
            <option value="mouseenter">mouseenter</option>
            <option value="mouseleave">mouseleave</option>
            <option value="mousemove">mousemove</option>
            <option value="mouseout">mouseout</option>
            <option value="mouseover">mouseover</option>
            <option value="mouseup">mouseup</option>
        </select>
        <label for="mouse-event-select">wybierz typ eventu</label>
        <table id="mouse-event-table" ref={tableRef}>
            <tr>
                <th className='mouse-event-th'>Nazwa</th>
                <th className='mouse-event-th'>Wartość</th>
            </tr>
        </table>
      </section>
      </div>
      
    );
}

